import tailwindConfig from 'tailwind.config';

export const HEADER_LG_MEDIA_QUERY = `(max-width: ${
  parseInt(tailwindConfig.theme.screens.headerLg) - 1
}px)`;
